var _rect, _g, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApproval(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    transform: "translate(0 0.5)",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10393_49103)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7658 8.12741L12.5706 8.93217L14.3813 7.12146M16.192 8.3286C16.192 10.3037 14.0377 11.7401 13.2538 12.1974C13.1647 12.2494 13.1202 12.2754 13.0573 12.2889C13.0085 12.2993 12.9374 12.2993 12.8886 12.2889C12.8257 12.2754 12.7812 12.2494 12.6921 12.1974C11.9082 11.7401 9.75391 10.3037 9.75391 8.3286V6.40425C9.75391 6.08255 9.75391 5.92169 9.80652 5.78342C9.853 5.66127 9.92853 5.55228 10.0266 5.46587C10.1376 5.36806 10.2882 5.31158 10.5894 5.19862L12.7469 4.38956C12.8305 4.35819 12.8724 4.34251 12.9154 4.33629C12.9536 4.33077 12.9923 4.33077 13.0305 4.33629C13.0735 4.34251 13.1154 4.35819 13.199 4.38956L15.3565 5.19862C15.6577 5.31158 15.8083 5.36806 15.9193 5.46587C16.0174 5.55228 16.0929 5.66127 16.1394 5.78342C16.192 5.92169 16.192 6.08255 16.192 6.40425V8.3286Z",
    stroke: "#FF7B01",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.57031 10.1857H7.77031M4.42746 13.1571H6.65603",
    stroke: "#FF7B01",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.77065 7.21387H3.19922C2.64693 7.21387 2.19922 7.66158 2.19922 8.21387V15.4996C2.19922 16.0519 2.64693 16.4996 3.19922 16.4996H14.9421C15.4944 16.4996 15.9421 16.0519 15.9421 15.4996V12.7853",
    stroke: "#FF7B01",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10393_49103"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.65714,
    height: 9.65714,
    fill: "white",
    transform: "translate(8.14453 3.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproval);
export default __webpack_public_path__ + "static/media/approval.86f8a182215f36037610a5c4ab3b9887.svg";
export { ForwardRef as ReactComponent };